import { useEffect, useState } from "react";
import { useLoadProfile } from "@/store/auth/auth.service";
import { AuthStore } from "@/store/auth/auth.store";
import { SettingsStore } from "@/store/settings/settings.store";
import { useUpdateProfile } from "@/store/settings/settings.service";
import { useTranslation } from "react-i18next";
import { Modal } from "@/components/Modals/Modal.component";

export const useProfileLanguageSync = () => {
  const { data: profileData } = useLoadProfile();
  const { updateUser } = AuthStore();
  const { t } = useTranslation();
  const [updateLanguageModalOpen, setUpdateLanguageModalOpen] = useState(false);

  useEffect(() => {
    if (profileData) {
      (async () => {
        await updateUser(profileData);
        const { shouldUpdateLanguageTo, language } = profileData;
        const lang = SettingsStore.getState().getLanguage();

        if (shouldUpdateLanguageTo && shouldUpdateLanguageTo !== lang) {
          setUpdateLanguageModalOpen(true);
        } else if (language) {
          SettingsStore.getState().setLanguage(language);
        }
      })();
    }
  }, [profileData, updateUser]);

  const { mutate: updateProfile } = useUpdateProfile({
    onSuccess: () => {
      setUpdateLanguageModalOpen(false);
    },
    onError: () => {
      setUpdateLanguageModalOpen(false);
    },
  });

  const LanguageUpdateModal = () => (
    <Modal
      title={t("settings.updateLanguageModal.title")}
      subtitle={t("settings.updateLanguageModal.subtitle")}
      open={updateLanguageModalOpen}
      closeBtn
      onClose={() => {
        setUpdateLanguageModalOpen(false);
      }}
      primaryBtn={{
        label: t('buttons.change'),
        onClick: () => {
          const lang = profileData?.shouldUpdateLanguageTo;
          if (lang) {
            SettingsStore.getState().setLanguage(lang);
          }
          updateProfile({
            shouldUpdateLanguageTo: '',
            language: lang
          });
        }
      }}
      secondaryBtn={{
        label: t('buttons.keep'),
        onClick: () => {
          updateProfile({
            shouldUpdateLanguageTo: ''
          });
        }
      }}
    />
  );

  return { LanguageUpdateModal };
};
